import React from 'react';

import { Assignment, Public, Settings } from '@material-ui/icons';

import {
  faClipboard,
  faFileSignature,
  faSeedling,
  faTasks,
  faFileInvoiceDollar,
  faTachometerAlt,
  faArrowLeft,
  faArrowRight
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';

const faReports = {
  prefix: 'fas',
  iconName: 'reports',
  icon: [
    20,
    20,
    [],
    '',
    'M2.02539 12.0008C2.02539 17.1908 5.97539 21.4508 11.0254 21.9508V14.8208C9.86539 14.4008 9.02539 13.3008 9.02539 12.0008C9.02539 10.7008 9.86539 9.60078 11.0254 9.18078V2.05078C5.97539 2.55078 2.02539 6.81078 2.02539 12.0008ZM21.9754 11.0008H14.8454C14.5354 10.1508 13.8754 9.49078 13.0254 9.18078V2.05078C17.7454 2.52078 21.5054 6.28078 21.9754 11.0008ZM19.4454 8.99813C18.6254 6.99813 17.0254 5.39812 15.0254 4.57812V8.00813C15.3954 8.28813 15.7354 8.62813 16.0154 8.99813H19.4454ZM13.0254 21.95V14.82C13.8754 14.51 14.5354 13.85 14.8454 13H21.9754C21.5054 17.72 17.7454 21.48 13.0254 21.95Z'
  ]
};

const faJug = {
  prefix: 'fas',
  iconName: 'jug',
  icon: [
    17,
    10,
    [],
    '',
    'M6.46303 1.41505L5.54665 0.353487C3.7006 0.285438 0.108121 1.25582 0.506548 5.68173C0.283429 5.87772 0.121402 6.03559 0.068278 6.09003C-0.0114074 9.10461 -0.0871085 15.3624 0.24757 16.277C0.454752 16.9466 1.52918 17.0323 2.04049 16.9915C2.04049 16.9915 8.08994 16.8622 8.51493 16.8486C8.93992 16.835 9.7899 16.4706 9.7899 16.046C9.7899 15.9656 9.80188 15.6982 9.82012 15.2911C9.89825 13.5471 10.0913 9.23933 9.94927 6.09003C9.93457 5.76404 9.92088 5.41778 9.90704 5.0679C9.84765 3.56642 9.78563 1.99833 9.63053 1.68045C9.59068 1.59879 9.39147 1.4763 9.39147 1.4763C9.39147 1.4763 9.44327 1.12108 9.49108 1.08842C9.53889 1.05575 9.41803 0.448756 9.35163 0.14934C8.78719 0.0132421 7.44715 -0.152798 6.60248 0.271829C6.57061 0.892437 6.54936 1.11564 6.54272 1.14966C6.56264 1.18369 6.60248 1.2844 6.60248 1.41505H6.46303ZM5.54665 1.96626C5.42712 1.63963 5.01675 1.08434 4.33145 1.47631C4.17208 1.27216 3.4828 1.45181 3.27562 1.84377C3.2557 1.84377 2.55845 1.84377 2.37916 2.5787C2.37729 2.58062 2.37068 2.58488 2.36024 2.59159C2.25958 2.65639 1.80331 2.9501 1.82136 3.57903C1.50262 4.19147 1.30341 5.04889 2.23971 5.04889C2.93031 4.99445 4.55855 4.30171 5.54665 1.96626Z'
  ]
};

const faPeople = {
  prefix: 'fas',
  iconName: 'people',
  icon: [
    14,
    12,
    [],
    '',
    'M3.81017 4.80005C3.14753 4.80005 2.51204 4.5472 2.04348 4.09711C1.57493 3.64703 1.3117 3.03659 1.3117 2.40007C1.3117 1.76356 1.57493 1.15311 2.04348 0.703027C2.51204 0.252943 3.14753 8.82112e-05 3.81017 8.82112e-05C4.4728 8.82112e-05 5.1083 0.252943 5.57685 0.703027C6.04541 1.15311 6.30864 1.76356 6.30864 2.40007C6.30864 3.03659 6.04541 3.64703 5.57685 4.09711C5.1083 4.5472 4.4728 4.80005 3.81017 4.80005ZM3.81017 5.40005C5.1531 5.40005 6.43356 5.64005 7.62034 6.05404L6.93326 9.60002H6.15248L5.68402 12H1.93631L1.46785 9.60002H0.687079L0 6.05404C1.22092 5.62529 2.51022 5.40398 3.81017 5.40005ZM9.00074 5.50205C9.82524 5.61005 10.6185 5.79005 11.3743 6.05404L10.681 9.60002H9.90019L9.43173 12H6.95824L7.18935 10.8H7.97012L9.00074 5.50205ZM7.55787 8.82112e-05C7.92349 -0.00292286 8.28535 0.0711868 8.61789 0.217187C8.95044 0.363186 9.24557 0.577518 9.48246 0.845053C9.71935 1.11259 9.89223 1.42681 9.98888 1.76553C10.0855 2.10426 10.1036 2.45924 10.0419 2.80541C9.98009 3.15158 9.83998 3.48051 9.63142 3.76899C9.42285 4.05746 9.15091 4.29845 8.8348 4.47494C8.51868 4.65143 8.16609 4.75912 7.80191 4.79042C7.43773 4.82171 7.07084 4.77585 6.72713 4.65605C7.26682 4.01848 7.56144 3.22181 7.56144 2.40007C7.56144 1.57833 7.26682 0.781664 6.72713 0.144087C6.99572 0.0600878 7.2643 8.82112e-05 7.55787 8.82112e-05Z'
  ]
};

const faRecommendations = {
  prefix: 'fas',
  iconName: 'recommendations',
  icon: [
    14,
    12,
    [],
    '',
    'M7.49779 12.8439C7.4067 12.6676 7.24798 12.6498 7.18375 12.6498C7.11953 12.6498 6.96081 12.6673 6.87435 12.8341L6.63751 13.2909C6.44081 13.6714 5.86462 13.6294 5.72721 13.2286L5.20752 11.7258L4.87989 12.6751C4.69802 13.2009 4.18883 13.5544 3.61387 13.5544H3.23128C2.95831 13.5544 2.73722 13.3412 2.73722 13.078C2.73722 12.8147 2.95831 12.6015 3.23128 12.6015H3.61387C3.76301 12.6015 3.89517 12.5098 3.94242 12.3735L4.5041 10.7465C4.606 10.4544 4.88823 10.2579 5.20752 10.2579C5.5268 10.2579 5.80903 10.4541 5.91062 10.7465L6.33922 11.9864C6.94908 11.5043 8.00852 11.6975 8.37721 12.408C8.43558 12.5205 8.54674 12.5852 8.66624 12.5944V10.1492L12.6187 6.36496V4.97888H8.4189C8.0113 4.97888 7.67781 4.6573 7.67781 4.26426V0.214722H1.50207C1.09139 0.214722 0.760986 0.533325 0.760986 0.929346V14.7454C0.760986 15.1414 1.09139 15.46 1.50207 15.46H11.8773C12.288 15.46 12.6184 15.1414 12.6184 14.7454V13.5544L8.66593 13.5511C8.16817 13.5419 7.72166 13.2748 7.49779 12.8439ZM12.6184 3.84442C12.6184 3.65683 12.5412 3.47519 12.4023 3.3412L9.37923 0.423154C9.24027 0.289162 9.05191 0.214722 8.85429 0.214722H8.66593V4.02605H12.6184V3.84442ZM9.65405 10.5458V12.6015H11.7844L16.7768 7.7546L14.6808 5.73341L9.65405 10.5458ZM18.3168 5.19714L17.3327 4.24818C17.0257 3.95221 16.5276 3.95221 16.2207 4.24818L15.3793 5.05958L17.4753 7.08077L18.3168 6.26937C18.624 5.9734 18.624 5.49311 18.3168 5.19714Z'
  ]
};

const faProducts = {
  prefix: 'fas',
  iconName: 'products',
  icon: [
    10,
    17,
    [],
    '',
    'M6.46303 1.41505L5.54665 0.353487C3.7006 0.285438 0.108121 1.25582 0.506548 5.68173C0.283429 5.87772 0.121402 6.03559 0.068278 6.09003C-0.0114074 9.10461 -0.0871085 15.3624 0.24757 16.277C0.454752 16.9466 1.52918 17.0323 2.04049 16.9915C2.04049 16.9915 8.08994 16.8622 8.51493 16.8486C8.93992 16.835 9.7899 16.4706 9.7899 16.046C9.7899 15.9656 9.80188 15.6982 9.82012 15.2911C9.89825 13.5471 10.0913 9.23933 9.94927 6.09003C9.93457 5.76404 9.92088 5.41778 9.90704 5.0679C9.84765 3.56642 9.78563 1.99833 9.63053 1.68045C9.59068 1.59879 9.39147 1.4763 9.39147 1.4763C9.39147 1.4763 9.44327 1.12108 9.49108 1.08842C9.53889 1.05575 9.41803 0.448756 9.35163 0.14934C8.78719 0.0132421 7.44715 -0.152798 6.60248 0.271829C6.57061 0.892437 6.54936 1.11564 6.54272 1.14966C6.56264 1.18369 6.60248 1.2844 6.60248 1.41505H6.46303ZM5.54665 1.96626C5.42712 1.63963 5.01675 1.08434 4.33145 1.47631C4.17208 1.27216 3.4828 1.45181 3.27562 1.84377C3.2557 1.84377 2.55845 1.84377 2.37916 2.5787C2.37729 2.58062 2.37068 2.58488 2.36024 2.59159C2.25958 2.65639 1.80331 2.9501 1.82136 3.57903C1.50262 4.19147 1.30341 5.04889 2.23971 5.04889C2.93031 4.99445 4.55855 4.30171 5.54665 1.96626Z'
  ]
};

const products = {
  prefix: 'fab',
  iconName: 'farm-storage',
  icon: [
    24,
    24,
    [],
    '',
    'M1 11.4L12 3L23 11.4L21.79 12.98L20 11.62V21H4V11.62L2.21 12.99L1 11.4ZM18 19H17V15H15V11H9V15H7V19H6V10.1L12 5.52L18 10.1V19ZM9 17V19H11V17H9ZM13 17V19H15V17H13ZM13 15V13H11V15H13Z'
  ]
};

const faIntegrations = {
  prefix: 'fas',
  iconName: 'integrations',
  icon: [
    20,
    20,
    [],
    '',
    'M11.4107 5.54475C11.4103 4.89543 10.887 4.35266 10.2376 4.35266C9.58813 4.35266 9.05844 4.89543 9.05803 5.54475L7.78947 5.68421L6.68339 5.55022C6.6838 3.60157 8.2888 2 10.2376 2C12.1863 2 13.7695 3.60157 13.7699 5.55022L12.5263 5.68421L11.4107 5.54475Z M10.2365 18.4691C10.8859 18.4691 11.4124 18.9953 11.4129 19.6446L12.5873 19.802L13.7815 19.6662C13.7811 17.7175 12.1853 16.1164 10.2365 16.1164C8.28778 16.1164 6.69673 17.7175 6.69632 19.6662L7.78947 19.8947L9.0602 19.6446C9.06061 18.9953 9.58711 18.4691 10.2365 18.4691Z M18.4691 17.2934V19.6662C18.4691 20.9655 17.4158 22.0188 16.1164 22.0188H12.5873V22.0031H7.88196V22.0188H4.35317C3.05383 22.0188 2.00051 20.9655 2.00051 19.6662L2 11.4201L2.00051 11.4165V7.90288C2.00051 6.60354 3.05383 5.55022 4.35317 5.55022H6.68339L9.05803 5.54475V7.89669H11.4107V5.54475L13.7699 5.55022H16.1164C17.4158 5.55022 18.4691 6.60354 18.4691 7.90288V10.2354H18.471C20.42 10.2354 22 11.8154 22 13.7644C22 15.7134 20.42 17.2934 18.471 17.2934H18.4691ZM17.2925 14.9407H18.471C19.1207 14.9407 19.6473 14.414 19.6473 13.7644C19.6473 13.1147 19.1207 12.588 18.471 12.588H18.4693V12.599H16.1164L16.1164 7.90288H4.35317V10.2354C6.30217 10.2354 7.88245 11.8154 7.88245 13.7644C7.88245 15.7134 6.30247 17.2934 4.35346 17.2934L4.35317 19.6662L9.05803 19.6505V22.0024H11.4107V19.6505H12.5873L16.1164 19.6662L16.1164 14.9517H17.2925V14.9407ZM4.35314 16.1218V16.1175H2.00051V16.1218H4.35314ZM4.35346 14.9407C5.00313 14.9407 5.52979 14.414 5.52979 13.7644C5.52979 13.1147 5.00313 12.588 4.35347 12.588L2.00051 12.5875V14.9402L4.35346 14.9407Z'
  ]
};

const faChevronDoubleRight = {
  prefix: 'fas',
  iconName: 'doubleChevronRight',
  icon: [
    13,
    13,
    [],
    '',
    'M7.55 14.75L14.75 8L7.55 1.25M1.25 14.75L8.45 8L1.25 1.25'
  ]
};

const faChevronDoubleLeft = {
  prefix: 'fas',
  iconName: 'doubleChevronLeft',
  icon: [
    13,
    13,
    [],
    '',
    'M8.45 1.25L1.25 8L8.45 14.75M14.75 1.25L7.55 8L14.75 14.75'
  ]
};

library.add(faJug, faReports, faPeople, faRecommendations);

const AnalysisIcon = (
  <FontAwesomeIcon fixedWidth size="1x" icon={faClipboard} />
);

const ContractsIcon = (
  <FontAwesomeIcon fixedWidth size="1x" icon={faFileSignature} />
);

const CropSeasonIcon = (
  <FontAwesomeIcon fixedWidth size="1x" icon={faSeedling} />
);

const DashboardIcon = (
  <FontAwesomeIcon fixedWidth size="1x" icon={faTachometerAlt} />
);

const InvoiceIcon = (
  <FontAwesomeIcon fixedWidth size="1x" icon={faFileInvoiceDollar} />
);

const OrganizationsIcon = <Settings />;

const PlanIcon = <Assignment />;

const PropertiesIcon = <Public />;

const RecommendationsIcon = (
  <FontAwesomeIcon fixedWidth size="1x" icon={faRecommendations} />
);

const ReportsIcon = <FontAwesomeIcon fixedWidth size="1x" icon={faReports} />;

const TasksIcon = <FontAwesomeIcon fixedWidth size="1x" icon={faTasks} />;

const InventoryIcon = (
  <FontAwesomeIcon fixedWidth size="1x" icon={faProducts} />
);

const ProductsIcon = (
  <FontAwesomeIcon
    size="lg"
    fill="none"
    fillRule="evenodd"
    xmlns="http://www.w3.org/2000/svg"
    clipRule="evenodd"
    icon={products}
  />
);

const IntegrationIcon = (
  <FontAwesomeIcon fixedWidth size="1x" icon={faIntegrations} />
);

const ChevronDoubleRight = (
  <FontAwesomeIcon
    size="1x"
    icon={faChevronDoubleRight}
    stroke="white"
    className="relative -top-05"
    fillOpacity={0}
    data-testid="faChevronDoubleRight"
  />
);

const ChevronDoubleLeft = (
  <FontAwesomeIcon
    size="1x"
    icon={faChevronDoubleLeft}
    stroke="white"
    className="relative -top-05"
    fillOpacity={0}
    data-testid="faChevronDoubleLeft"
  />
);

const ArrowLeft = <FontAwesomeIcon fixedWidth size="1x" icon={faArrowLeft} />;

const ArrowRight = <FontAwesomeIcon fixedWidth size="1x" icon={faArrowRight} />;

export {
  AnalysisIcon,
  ContractsIcon,
  CropSeasonIcon,
  DashboardIcon,
  InvoiceIcon,
  OrganizationsIcon,
  PlanIcon,
  ProductsIcon,
  InventoryIcon,
  PropertiesIcon,
  RecommendationsIcon,
  ReportsIcon,
  TasksIcon,
  IntegrationIcon,
  ChevronDoubleRight,
  ChevronDoubleLeft,
  ArrowLeft,
  ArrowRight
};
